import React from 'react';
import CancellationDetail from './CancellationDetail';

const CancellationDetailRoute = () => {
  return <CancellationDetail />;
};

export default CancellationDetailRoute;